export default class Store {
    constructor(){}

    setUniverseID(id){
        localStorage.setItem('universe_id', id);
    }

    setHeroID(id){
        localStorage.setItem('hero_id', id);
    }

    setStoryID(id){
        localStorage.setItem('story_id', id);
    }

    getUniverseID(){
        return localStorage.getItem('universe_id');
    }

    getHeroID(){
        return localStorage.getItem('hero_id');
    }

    getStoryID(){
        return localStorage.getItem('story_id');
    }
}